<template>
  <div class="error-screen">
    <h2 class="error-screen__title brand-font_300">Oops! Something's gone wrong</h2>
    <p class="error-screen__message">
      Our credit club platform is currently down. Our techies are working furiously to fix the issue and
      we're hoping to be up soon.
    </p>
    <div class="error-screen__services">
      <div class="service">
        <h3 class="service__title brand-font_500">Cheap Energy Club</h3>
        <p class="service__message">
          Helping you get no-hassle, <i>CONSTANTLY</i> cheap gas & electricity
        </p>
        <div class="service__links-wrapper service__links-wrapper_orange">
          <nav>
            <ul class="service__list">
              <li class="service__list-item">
                <a
                  href="https://www.moneysavingexpert.com/dashboard"
                  class="service__link"
                  target="_self"
                  >My account</a
                >
              </li>
              <li class="service__list-item">
                <a
                  href="http://www.moneysavingexpert.com/cheapenergyclub"
                  class="service__link"
                  target="_self"
                  >Home</a
                >
              </li>
              <li class="service__list-item">
                <a
                  :href="FAQ_URL"
                  class="service__link"
                  target="_self"
                  >FAQs</a
                >
              </li>
              <li class="service__list-item">
                <a
                  href="https://www.moneysavingexpert.com/login/"
                  class="service__link"
                  target="_self"
                  >Register</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="service">
        <h3 class="service__title brand-font_500">Credit Club</h3>
        <p class="service__message">Totally free way to boost your credit chances</p>
        <div class="service__links-wrapper service__links-wrapper_green">
          <nav>
            <ul class="service__list">
              <li class="service__list-item">
                <router-link :to="{ name: 'EligibilityRating' }" class="service__link"
                  >Home</router-link
                >
              </li>
              <li class="service__list-item">
                <a
                  href="http://www.moneysavingexpert.com/creditclub"
                  class="service__link"
                  target="_self"
                  >Home</a
                >
              </li>
              <li class="service__list-item">
                <a
                  :href="FAQ_URL"
                  class="service__link"
                  target="_self"
                  >FAQs</a
                >
              </li>
              <li class="service__list-item">
                <a
                  href="https://www.moneysavingexpert.com/login?target=%2Fcreditclub%2Ftu%2Fregister"
                  class="service__link"
                  target="_self"
                  >Register</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FAQ_URL } from '@/constants/urls';
</script>

<style scoped lang="scss">
  .error-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 41px 15px;

    &__message {
      margin-top: 20px;
      font-size: remc(16px);
      line-height: remc(25px);
      text-align: center;

      @include md {
        font-size: remc(15px);
      }

      @include sm {
        font-size: remc(14px);
        line-height: remc(22px);
      }
    }

    &__services {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
      align-self: stretch;
      margin-top: 17px;

      @include md {
        grid-template-columns: 1fr;
        grid-gap: 40px;
      }

      @include sm {
        padding: 0 25px;
      }
    }
  }

  .service {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 24px;
    background: $main-bg;
    border: 1px solid $white-3;

    &__message {
      font-size: remc(13px);
      font-weight: bold;
      line-height: remc(16px);
      color: $brand-gray;
      text-align: center;

      @include lg {
        min-height: 48px;
      }

      @include md {
        min-height: auto;
      }
    }

    &__links-wrapper {
      align-self: stretch;
      padding: 24px 24px 30px;
      margin-top: 15px;
      background: $white;
      box-shadow: 0 2px 2px $black-rgb-20;

      @include sm {
        margin: 15px -35px 0;
      }

      &_orange {
        border-top: 3px solid $orange-4;
      }

      &_green {
        border-top: 3px solid $teal-1;
      }
    }

    &__list-item {
      padding-bottom: 10px;
      margin-top: 10px;
      text-align: center;
      border-bottom: 1px solid $white-3;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &__link {
      font-size: remc(14px);
      font-weight: bold;
      line-height: remc(23px);
      color: $link-text;

      @include md {
        font-size: remc(13px);
      }

      @include sm {
        font-size: remc(12px);
        line-height: remc(20px);
      }

      &:hover {
        color: $link-text;
      }
    }
  }
</style>
